import { useEffect, useState } from 'react';
import { get } from '../../services/apiController';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Kitchen = ({ query, kitchenId, onChange, name, isDisabled = false, label }) => {
  const [kitchens, setKitchens] = useState([]);
  const [selectedKitchen, setSelectedKitchen] = useState(null);

  const fetchKitchens = () => {
    try {
      let url;
      if (query) {
        url = `/inv/kitchen/?${query}`;
      } else {
        url = '/inv/kitchen';
      }
      get(url).then((response) => {
        setKitchens(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  useEffect(() => {
    fetchKitchens();
  }, [query]);

  useEffect(() => {
    if (kitchenId) {
      const kitchen = kitchens.find((ele) => ele.id === +kitchenId);
      setSelectedKitchen({ value: kitchen?.id, label: kitchen?.name });
    }
  }, [kitchenId, kitchens]);

  const options = kitchens.map((kitchen) => ({
    value: kitchen?.id,
    label: kitchen?.name,
  }));

  return (
    <Select
      name={name}
      placeholder={label ?? 'Select Kitchen'}
      isDisabled={isDisabled}
      value={selectedKitchen}
      isClearable
      isSearchable
      options={options}
      onChange={(selectedKitchen) => {
        setSelectedKitchen({ value: selectedKitchen?.value, label: selectedKitchen?.label });
        onChange(selectedKitchen?.value ?? '');
      }}
      styles={{
        control: (provided, state) => ({
          ...provided,
          minHeight: '55px', // Adjust the height value as needed
        }),
      }}
    />
  );
};

export default Kitchen;
